export default "__VITE_ASSET__ba7f788c__"